import React from 'react';

interface StepProgressProps {
  currentStep: number;
  totalSteps: number;
}

export const StepProgress: React.FC<StepProgressProps> = ({
  currentStep,
  totalSteps,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        justifyContent: 'center',
        marginBottom: 20,
      }}
    >
      {Array.from({ length: totalSteps }).map((_, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < currentStep;
        const isCurrent = stepNumber === currentStep;

        return (
          <React.Fragment key={stepNumber}>
            <div
              style={{
                width: isCurrent ? 28 : 24,
                height: isCurrent ? 28 : 24,
                borderRadius: '50%',
                background: isCompleted || isCurrent
                  ? 'linear-gradient(135deg, #6B7FFF 0%, #5A6EE6 100%)'
                  : '#e2e8f0',
                color: isCompleted || isCurrent ? 'white' : '#94a3b8',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 600,
                transition: 'all 0.3s',
                flexShrink: 0,
              }}
            >
              {isCompleted ? (
                <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              ) : (
                stepNumber
              )}
            </div>

            {stepNumber < totalSteps && (
              <div
                style={{
                  width: 40,
                  height: 2,
                  background: isCompleted
                    ? 'linear-gradient(90deg, #6B7FFF, #5A6EE6)'
                    : '#e2e8f0',
                  transition: 'all 0.3s',
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
